import React, { lazy, Suspense } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from '../../../../Layout/Auth'
import PurchaseOrderList from '../Pages/PurchaseOrderList'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'

const AddPurchaseOrder = lazy(() => import('../Pages/AddPurchaseOrder'))
const EditPurchaseOrder = lazy(() => import('../Pages/EditPurchaseOrder'))
const PurchaseOrderView = lazy(() => import('../Pages/PurchaseOrderView'))

function Loading() {
  return (
    <>
      <div className='wrapper'>
        <span>Loading</span>
      </div>
    </>
  )
}

function PurchaseOrderRoute() {
  const history = useHistory()

  return (
    <Switch>
      <Route
        exact
        path='/:lng/sales/purchase-orders'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <PurchaseOrderList history={history} />
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/purchase-orders/list'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <PurchaseOrderList history={history} />
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/purchase-orders/add'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <AddPurchaseOrder history={history} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/purchase-orders/edit/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <EditPurchaseOrder history={history} {...props} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        exact
        path='/:lng/sales/purchase-orders/view/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <Suspense fallback={<Loading />}>
              <PurchaseOrderView history={history} {...props} />
            </Suspense>
          </Auth>
        )}
      />

      <Route
        path='/:lng/sales/purchase-orders/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(PurchaseOrderRoute)
